export default __webpack_public_path__ + "static/media/map-explorer.884bf9d5.jpeg";